import React from 'react';

import Discord from './Discord.svg';
import Instagram from './Instagram.svg';
import styled from 'styled-components';
import StyledLink from './StyledLink';
import StyledLinksColumn from '../../ui-library/styled/StyledLinksColumn';
import { URL_DISCORD, URL_INSTAGRAM, URL_YOUTUBE } from './links.constants';
import YouTube from './YouTube.svg';
import { trackFooterSocialMediaClick } from '../tracking/discovery.tracking';
import {
  STR_DISCORD,
  STR_INSTAGRAM,
  STR_YOUTUBE,
} from '../tracking/discovery.tracking.constants';

const StyledSocialLink = styled(StyledLink)`
  margin-bottom: 24px;
`;
const StyledIcon = styled.img`
  width: 24px;
  height: 24px;
  padding: 0;
  margin: -4px 8px 0 0;
`;

const trackDiscordClick = () => {
  trackFooterSocialMediaClick(STR_DISCORD);
};
const trackInstagramClick = () => {
  trackFooterSocialMediaClick(STR_INSTAGRAM);
};
const trackYouTubeClick = () => {
  trackFooterSocialMediaClick(STR_YOUTUBE);
};
const SocialLinks = () => {
  return (
    <StyledLinksColumn>
      <div style={{ marginTop: '-12px' }}>
        <div>
          <StyledSocialLink
            to={{
              pathname: `${URL_DISCORD}`,
            }}
            target='_blank'
            onClick={trackDiscordClick}
          >
            <StyledIcon src={Discord} />
            Discord
          </StyledSocialLink>
        </div>
        <div style={{ marginTop: '6px' }}>
          <StyledSocialLink
            to={{
              pathname: `${URL_INSTAGRAM}`,
            }}
            target='_blank'
            onClick={trackInstagramClick}
          >
            <StyledIcon src={Instagram} />
            Instagram
          </StyledSocialLink>
        </div>
        <div style={{ marginTop: '6px' }}>
          <StyledSocialLink
            to={{
              pathname: `${URL_YOUTUBE}`,
            }}
            target='_blank'
            onClick={trackYouTubeClick}
          >
            <StyledIcon src={YouTube} />
            YouTube
          </StyledSocialLink>
        </div>
      </div>
    </StyledLinksColumn>
  );
};

export default SocialLinks;
